export { startReactDsfr } from "./zz_internal/start";
//# sourceMappingURL=index.js.map